import React from 'react'
import { MetricSeries, MessageConst } from 'enums'
import messageUtil from 'utils/messageUtil'

import PanelColumn from './PanelColumn'
import { resolveMetrics } from './utils'
import { NonNullableDataset } from './types'

interface NewsPanelProps {
  data: NonNullableDataset
}

const NewsPanel = ({ data }: NewsPanelProps) => {
  const { engagements, reposts, impressions } = resolveMetrics(data)

  return (
    <>
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.TOTAL_ENGAGEMENTS)}
        value={engagements}
      />
      <PanelColumn title={messageUtil.measureType('Reposts')} value={reposts} />
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.IMPRESSIONS)}
        value={impressions === '0' ? MessageConst.EM_DASH : impressions}
      />
    </>
  )
}
export default NewsPanel
